<mat-error *ngIf="control.invalid && (control.dirty || control.touched) && errorKey" @error>
  <!-- display first error -->
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '^[A-Za-z0-9]*$'">
    {{'ERRORS.alphabetNumber' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '^[0-9.]*$'">
    {{'ERRORS.onlyNumber' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '^(http|https)(.+)(jpg|png)$'">
    {{'ERRORS.' + errorKey | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^[a-zA-Z]+$/'">
    {{'ERRORS.patternAlphabet' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^[a-zA-Z\\-\\ ]+$/'">
    {{'ERRORS.patternAlphabetHyphenSpace' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^(?=.*[a-zA-Z])([a-zA-Z0-9 ]+)$/'">
    {{'ERRORS.alphaNumeric' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^([A-Za-z])([a-zA-Z0-9_])+( [a-zA-Z0-9_]+)*$/'">
    {{'ERRORS.alphaNumeric' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey !== 'pattern'">
    {{'ERRORS.' + errorKey | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^(?!000).*$/'">
    {{'ERRORS.Entervalidinput' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^ITSM[a-zA-Z0-9]*/'">
    {{'ERRORS.ticketNumber' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^ITSM-[a-zA-Z0-9].{1}|^CEPR-[a-zA-Z0-9].{1}/'">
    {{'ERRORS.ticketNumberItsm' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^[A-Za-z0-9._-]+$/'">
    {{'ERRORS.scheduleValidation' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '^[0-9]+(\\.[0-9]+)?$'">
  {{ 'ERRORS.onlyNumber' | transloco: errorParams }}
</span>
<span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '^[0-9]+(M|G)$'">
  {{ 'ERRORS.memoryFormat' | transloco: errorParams }}
</span>
</mat-error>
